import { create } from 'zustand';
import { persist } from 'zustand/middleware';

function applyDark(v: boolean) {
  document.documentElement.classList.toggle('dark', v);
}

interface ThemeState {
  isDark: boolean;
  toggle: () => void;
  setDark: (v: boolean) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      isDark: false,
      toggle: () => {
        const next = !get().isDark;
        applyDark(next);
        set({ isDark: next });
      },
      setDark: (v) => {
        applyDark(v);
        set({ isDark: v });
      },
    }),
    {
      name: 'trip-planner-theme',
      onRehydrateStorage: () => (state) => {
        if (state) applyDark(state.isDark);
      },
    },
  ),
);
